// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__QY069","actions":"GroupTable_actions__EcC79","deleteModalFooter":"GroupTable_deleteModalFooter__398s8"};